import type { JSX } from 'solid-js';

// The move glyphs (#6771, prototype `ICON.grip`, `ICON.swap`, `ICON.down`, `ICON.block`).
// Decorative: every control carries its own accessible name.

export type MoveGlyph = 'grip' | 'swap' | 'down' | 'block' | 'flow' | 'pause' | 'check';

const GLYPH: Readonly<Record<MoveGlyph, () => JSX.Element>> = {
  grip: () => (
    <g fill="currentColor">
      <circle cx="5" cy="4" r="1.15" />
      <circle cx="9" cy="4" r="1.15" />
      <circle cx="5" cy="8" r="1.15" />
      <circle cx="9" cy="8" r="1.15" />
      <circle cx="5" cy="12" r="1.15" />
      <circle cx="9" cy="12" r="1.15" />
    </g>
  ),
  swap: () => (
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M2.5 5h10.5M10.5 2.5L13 5l-2.5 2.5M13.5 11H3M5.5 8.5L3 11l2.5 2.5"
    />
  ),
  down: () => (
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M8 3v9M4 8.5l4 4 4-4"
    />
  ),
  block: () => (
    <g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">
      <circle cx="8" cy="8" r="5.75" />
      <path d="M4 12L12 4" />
    </g>
  ),
  // #6772: the prototype's `ICON.flow` (the simplified card's Move work, `:1308`), `ICON.pause`
  // (the meter at 0 left, `:1293`) and `ICON.check` (a move note, Moved, `:1302`).
  flow: () => (
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M2.5 5.5h9M9 3l2.5 2.5L9 8M13.5 10.5h-9M7 8l-2.5 2.5L7 13"
    />
  ),
  pause: () => (
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      d="M5.5 3.5v9M10.5 3.5v9"
    />
  ),
  check: () => (
    <path
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3.5 8.5l3 3 6-7"
    />
  ),
};

export function MoveIcon(props: { readonly glyph: MoveGlyph }): JSX.Element {
  return (
    <svg class="move-icon" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true">
      {GLYPH[props.glyph]()}
    </svg>
  );
}
